import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      if (!sid) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        await refreshUser();
        window.history.replaceState(null, "", window.location.pathname);
        navigate(data.needs_username ? "/choose-username" : "/account", { replace: true });
      } catch {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 text-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-velvet-rose border-t-transparent" />
      <p className="text-sm font-light text-white/50">{error || "Signing you in…"}</p>
    </div>
  );
}
